import { Button, Col, Row } from "reactstrap";
import { AboutApplicationDescription, AboutApplicationText, AboutApplicationTitle, Href, ViewMore } from "../../Constants/Constants";
import { AboutApplicationData } from "../../Data/Landing/Landing";
import { dynamicImage, Image } from "../../Utils";

const AboutApplication = () => {
  return (
    <section className="app-responsive section-py-space">
      <div className="custom-container">
        <Row className="align-items-center">
          <Col xs="12" md="6">
            <div className="app-box">
              <Image className="img-fluid" src={dynamicImage("index/mobile/1.png")} alt="app" />
              <Image className="img-fluid figma-file" src={dynamicImage("landing-page/responsive-app/figma-file.png")} alt="app" />
              <Image className="img-fluid printed-box" src={dynamicImage("landing-page/responsive-app/pretty-printed.png")} alt="app" />
            </div>
          </Col>
          <Col xs="12" md="6">
            <div className="app-text-box">
              <Image className="img-fluid" src={dynamicImage("landing-page/dark-logo.png")} alt="logo" />
              <h3>{AboutApplicationTitle}</h3>
              <h2>{AboutApplicationText}</h2>
              <p>{AboutApplicationDescription}</p>
              <ul className="home-info">
                {AboutApplicationData.map((item, index) => (
                  <li key={index}>
                    <div className="factors">
                      <Image src={dynamicImage("landing-page/responsive-app/hand.png")} alt="hand" />
                      <h4>{item}</h4>
                    </div>
                  </li>
                ))}
              </ul>
            <Button tag={"a"} href={Href}>{ViewMore}</Button>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default AboutApplication;
